(function() {
  function safeParseJson(sectionEl, selector) {
    const raw = sectionEl.querySelector(selector)?.textContent || '[]';
    try {
      return JSON.parse(raw);
    } catch (_error) {
      return [];
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.aiHubReady === 'true') return;
    sectionEl.dataset.aiHubReady = 'true';

    const materials = safeParseJson(sectionEl, '[data-materials-json]');
    const gallery = safeParseJson(sectionEl, '[data-gallery-json]');
    const featuredProducts = safeParseJson(sectionEl, '[data-featured-products-json]');
    const inspirationProducts = safeParseJson(sectionEl, '[data-inspiration-products-json]');
    const samplesProducts = safeParseJson(sectionEl, '[data-samples-products-json]');

    const tabs = sectionEl.querySelectorAll('[data-tab-trigger]');
    const panels = sectionEl.querySelectorAll('[data-tab-panel]');
    const topNavTabs = sectionEl.querySelectorAll('.nyct-hub__nav-tab[data-tab-trigger], .nyct-hub__nav-logo[data-tab-trigger]');
    const materialGrid = sectionEl.querySelector('[data-material-grid]');
    const featuredGrid = sectionEl.querySelector('[data-featured-grid]');
    const sampleGrid = sectionEl.querySelector('[data-sample-grid]');
    const materialEmpty = sectionEl.querySelector('[data-material-empty]');
    const galleryGrid = sectionEl.querySelector('[data-gallery-grid]');
    const galleryEmpty = sectionEl.querySelector('[data-gallery-empty]');
    const projectMaterialSelect = sectionEl.querySelector('[data-project-input="material"]');
    const projectSummary = sectionEl.querySelector('[data-project-summary] .nyct-hub__summary-body');
    const assistantOutput = sectionEl.querySelector('[data-assistant-output] .nyct-hub__summary-body');
    const assistantGrid = sectionEl.querySelector('[data-assistant-grid]');
    const quoteSummaryProjectField = sectionEl.querySelector('[data-quote-summary-block="project"]');
    const quoteSummaryCalculatorField = sectionEl.querySelector('[data-quote-summary-block="calculator"]');
    const quoteSummaryAssistantField = sectionEl.querySelector('[data-quote-summary-block="assistant"]');
    const sampleCount = sectionEl.querySelector('[data-sample-count]');
    const sampleList = sectionEl.querySelector('[data-sample-list]');
    const wallFields = sectionEl.querySelector('[data-wall-fields]');
    const calcInputs = sectionEl.querySelectorAll('[data-calc-input]');
    const calcResultsWrap = sectionEl.querySelector('[data-calc-results]');
    const calculatorStorageKey = 'nyct-ai-hub-calculator-state-' + String(sectionEl.dataset.sectionId || '');
    const projectSummaryCard = sectionEl.querySelector('[data-project-summary]');
    let materialGridProducts = null;

    let activeMaterialTag = 'all';
    let activeGalleryTag = 'all';
    let galleryGridProducts = null;
    let lastAssistantTags = [];
    let sampleVariantIds = [];
    let sampleInCartVariantIds = [];

    function saveCalculatorState() {
      const state = {};
      calcInputs.forEach(function(input) {
        state[input.dataset.calcInput] = input.value;
      });
      try {
        window.sessionStorage.setItem(calculatorStorageKey, JSON.stringify(state));
      } catch (_error) {}
    }

    function restoreCalculatorState() {
      try {
        const raw = window.sessionStorage.getItem(calculatorStorageKey);
        if (!raw) return;
        const state = JSON.parse(raw);
        calcInputs.forEach(function(input) {
          const key = input.dataset.calcInput;
          if (Object.prototype.hasOwnProperty.call(state, key)) {
            input.value = state[key];
          }
        });
      } catch (_error) {}
    }

    function resolveTab(tab) {
      const requested = String(tab || '').trim().toLowerCase();
      const aliases = {
        project: 'assistant',
        'project-design-builder': 'assistant'
      };
      const target = aliases[requested] || requested;
      const knownTabs = Array.from(panels).map(function(panel) { return String(panel.dataset.tabPanel || '').toLowerCase(); });
      if (knownTabs.indexOf(target) > -1) return target;
      return 'home';
    }

    function showTab(tab) {
      const activeTab = resolveTab(tab);
      panels.forEach(function(panel) {
        const isActive = panel.dataset.tabPanel === activeTab;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
      tabs.forEach(function(trigger) { trigger.classList.toggle('is-active', resolveTab(trigger.dataset.tabTrigger) === activeTab); });
      topNavTabs.forEach(function(trigger) { trigger.classList.toggle('is-active', resolveTab(trigger.dataset.tabTrigger) === activeTab); });
      const hubShopifySection = sectionEl.closest('.shopify-section');
      if (hubShopifySection) hubShopifySection.dataset.activeTab = activeTab;
    }

    function getInitialTabFromUrl() {
      const params = new URLSearchParams(window.location.search || '');
      const paramTab = (params.get('hub_tab') || params.get('nyct_tab') || '').trim().toLowerCase();
      const hashValue = String(window.location.hash || '').replace(/^#/, '').trim().toLowerCase();
      const knownTabs = Array.from(panels).map(function(panel) { return String(panel.dataset.tabPanel || '').toLowerCase(); });

      if (paramTab && knownTabs.indexOf(paramTab) > -1) return paramTab;
      if (hashValue && knownTabs.indexOf(hashValue) > -1) return hashValue;
      if (hashValue.indexOf('nyct-tab-') === 0) {
        const prefixedTab = hashValue.replace('nyct-tab-', '');
        if (knownTabs.indexOf(prefixedTab) > -1) return prefixedTab;
      }

      return '';
    }

    tabs.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        const targetTab = this.dataset.tabTrigger;
        const filterTag = (this.dataset.filterTag || '').trim();
        if (targetTab) showTab(targetTab);
        if (filterTag) {
          applyFilterToGroup('materials', filterTag);
          applyFilterToGroup('gallery', filterTag);
        }
      });
    });

    const initialTab = getInitialTabFromUrl();
    if (initialTab) showTab(initialTab);

    function initials(text) {
      return (text || '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(function(word) { return word.charAt(0).toUpperCase(); })
        .join('') || 'NY';
    }

    function normalizeTag(tag) {
      return String(tag || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');
    }

    function normalizeTags(tags) {
      return Array.isArray(tags)
        ? tags.map(function(tag) { return normalizeTag(tag); }).filter(Boolean)
        : [];
    }

    function displayTags(tags) {
      if (!Array.isArray(tags)) return [];
      const unique = new Set();
      const list = [];
      tags.forEach(function(tag) {
        const value = String(tag || '').trim();
        const key = value.toLowerCase();
        if (!value || unique.has(key)) return;
        unique.add(key);
        list.push(value);
      });
      return list;
    }

    function materialTags(material) {
      return normalizeTags(material.tags).concat(normalizeTags(material.product_tags));
    }

    function matchesTag(itemTags, tag) {
      if (!tag || tag === 'all') return true;
      return itemTags.indexOf(normalizeTag(tag)) > -1;
    }

    function renderMaterialCard(material, withSampleButton) {
      const mediaHtml = material.product_image
        ? '<a href="' + (material.product_url || '#') + '"><img class="nyct-hub__gallery-swatch" src="' + material.product_image + '" alt="' + (material.name || '') + '" loading="lazy"></a>'
        : '<div class="nyct-hub__swatch" style="background:' + (material.color || '#C8B89A') + '">' + initials(material.collection || material.name) + '</div>';
      const titleHtml = material.product_url
        ? '<h4 class="nyct-hub__material-title"><a href="' + material.product_url + '">' + (material.name || '') + '</a></h4>'
        : '<h4 class="nyct-hub__material-title">' + (material.name || '') + '</h4>';
      return '\n        <article class="nyct-hub__material-card">\n          ' + mediaHtml + '\n          <div class="nyct-hub__material-body">\n            <span class="nyct-hub__collection">' + (material.collection || '') + '</span>\n            ' + titleHtml + '\n            ' + (material.subtitle ? '<p class="nyct-hub__material-subtitle">' + material.subtitle + '</p>' : '') + '\n            <div class="nyct-hub__meta">\n              ' + (material.product_price ? '<div><strong>Price:</strong> ' + material.product_price + '</div>' : '') + '\n              ' + (material.sizes ? '<div><strong>Sizes:</strong> ' + material.sizes + '</div>' : '') + '\n              ' + (material.grout ? '<div><strong>Grout:</strong> ' + material.grout + '</div>' : '') + '\n              ' + (material.sealer ? '<div><strong>Sealer:</strong> ' + material.sealer + '</div>' : '') + '\n            </div>\n            ' + (withSampleButton && material.sampleable ? '<div class="nyct-hub__material-actions"><button class="nyct-hub__btn nyct-hub__btn--secondary nyct-hub__btn--small" type="button" data-sample-toggle="' + material.id + '">' + (selectedSamples.indexOf(material.id) > -1 ? 'Remove sample' : 'Add sample') + '</button></div>' : '') + '\n          </div>\n        </article>\n      ';
    }

    function renderFeatured() {
      if (!featuredGrid) return;
      featuredGrid.innerHTML = featuredProducts.filter(function(item) {
        return matchesTag(normalizeTags(item.tags), activeMaterialTag);
      }).map(function(item) {
        return '\n          <article class="nyct-hub__material-card">\n            <a href="' + item.url + '">\n              ' + (item.image ? '<img class="nyct-hub__gallery-swatch" src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">' : '<div class="nyct-hub__gallery-swatch" style="background:#C8B89A"></div>') + '\n            </a>\n            <div class="nyct-hub__material-body">\n              <span class="nyct-hub__collection">' + (item.collection || '') + '</span>\n              <h4 class="nyct-hub__material-title"><a href="' + item.url + '">' + (item.title || '') + '</a></h4>\n              ' + (item.subtitle ? '<p class="nyct-hub__material-subtitle">' + item.subtitle + '</p>' : '') + '\n              <div class="nyct-hub__meta">\n                <div><strong>Price:</strong> ' + (item.price || '') + '</div>\n                ' + (item.compare_at_price ? '<div><strong>Compare at:</strong> ' + item.compare_at_price + '</div>' : '') + '\n              </div>\n            </div>\n          </article>\n        ';
      }).join('');
    }

    function renderMaterials() {
      if (!materialGrid) return;
      const source = Array.isArray(materialGridProducts) ? materialGridProducts : materials;
      const list = source.filter(function(item) {
        return matchesTag(materialTags(item), activeMaterialTag);
      });
      materialGrid.innerHTML = list.map(function(item) { return renderMaterialCard(item, false); }).join('');
      if (materialEmpty) materialEmpty.hidden = list.length > 0;
    }

    function renderSampleGrid() {
      if (!sampleGrid) return;
      const source = Array.isArray(samplesProducts) && samplesProducts.length
        ? samplesProducts
        : [];
      sampleVariantIds = source.map(function(item) { return Number(item.variant_id || 0); }).filter(Boolean);
      const list = source.filter(function(item) {
        return matchesTag(materialTags(item), activeMaterialTag);
      });

      sampleGrid.innerHTML = list.map(function(item) {
        const addLabel = item.available ? 'Add to cart' : 'Sold out';

        return '\n          <article class="nyct-hub__material-card">\n            ' + (item.product_image ? '<a href="' + (item.product_url || '#') + '"><img class="nyct-hub__gallery-swatch" src="' + item.product_image + '" alt="' + (item.name || '') + '" loading="lazy"></a>' : '<div class="nyct-hub__gallery-swatch" style="background:#C8B89A"></div>') + '\n            <div class="nyct-hub__material-body">\n              <span class="nyct-hub__collection">' + (item.collection || '') + '</span>\n              <h4 class="nyct-hub__material-title"><a href="' + (item.product_url || '#') + '">' + (item.name || '') + '</a></h4>\n              ' + (item.subtitle ? '<p class="nyct-hub__material-subtitle">' + item.subtitle + '</p>' : '') + '\n              <div class="nyct-hub__meta">' + (item.product_price ? '<div><strong>Price:</strong> ' + item.product_price + '</div>' : '') + '</div>\n              <div class="nyct-hub__material-actions">\n                <button class="nyct-hub__btn nyct-hub__btn--secondary nyct-hub__btn--small" type="button" data-sample-add="' + (item.variant_id || '') + '" data-sample-available="' + (item.available && item.variant_id ? 'true' : 'false') + '" ' + (!item.available || !item.variant_id ? 'disabled' : '') + '>' + addLabel + '</button>\n              </div>\n            </div>\n          </article>\n        ';
      }).join('');

      sampleGrid.querySelectorAll('[data-sample-add]').forEach(function(button) {
        button.addEventListener('click', async function() {
          const variantId = parseInt(this.dataset.sampleAdd || '0', 10);
          if (!variantId) return;

          this.disabled = true;
          this.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });

            if (!response.ok) {
              throw new Error('Unable to add item');
            }

            await response.json();
            await refreshSampleCartStatus();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (_error) {
            renderSampleCart('Could not add item to cart. Please try again.');
            this.disabled = false;
          } finally {
            this.removeAttribute('aria-busy');
          }
        });
      });

      syncSampleButtonsWithCartState();
    }

    function renderSampleCart(message) {
      if (!sampleCount || !sampleList) return;
      sampleCount.textContent = '';
      sampleList.textContent = message || 'Choose a product and click Add to cart.';
    }

    async function refreshSampleCartStatus() {
      if (!sampleCount || !sampleList) return;

      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) {
          throw new Error('Unable to load cart');
        }

        const cart = await response.json();
        const items = Array.isArray(cart?.items) ? cart.items : [];
        const sampleItems = items
          .map(function(item, index) {
            return {
              line: index + 1,
              variant_id: Number(item.variant_id || 0),
              title: item.product_title || item.title || '',
              quantity: Number(item.quantity || 0),
              image: item.image || ''
            };
          })
          .filter(function(item) { return sampleVariantIds.indexOf(item.variant_id) > -1; });
        sampleInCartVariantIds = sampleItems.map(function(item) { return item.variant_id; });

        sampleCount.textContent = '(' + sampleItems.length + ')';

        if (!sampleItems.length) {
          sampleList.textContent = 'No sample items in cart yet.';
          return;
        }

        sampleList.innerHTML = sampleItems.map(function(item) {
          return '\n            <div class="nyct-hub__sample-row">\n              <div class="nyct-hub__sample-row-left">\n                ' + (item.image ? '<img src=\"' + item.image + '\" alt=\"' + item.title + '\" width=\"28\" height=\"28\" style=\"border-radius:6px;object-fit:cover;\">' : '') + '\n                <div>' + item.title + ' <span class=\"nyct-hub__collection\">x' + item.quantity + '</span></div>\n              </div>\n              <button class=\"nyct-hub__btn nyct-hub__btn--secondary nyct-hub__btn--small\" type=\"button\" data-sample-remove-line=\"' + item.line + '\">Remove</button>\n            </div>\n          ';
        }).join('');

        sampleList.querySelectorAll('[data-sample-remove-line]').forEach(function(button) {
          button.addEventListener('click', async function() {
            const line = Number(this.dataset.sampleRemoveLine || 0);
            if (!line) return;

            this.disabled = true;
            this.setAttribute('aria-busy', 'true');
            try {
              const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ line: line, quantity: 0 })
              });

              if (!res.ok) throw new Error('Unable to remove item');
              await refreshSampleCartStatus();
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              syncSampleButtonsWithCartState();
            } catch (_error) {
              renderSampleCart('Could not remove item. Please try again.');
            } finally {
              this.removeAttribute('aria-busy');
            }
          });
        });
        syncSampleButtonsWithCartState();
      } catch (_error) {
        renderSampleCart('Could not load cart status.');
      }
    }

    function syncSampleButtonsWithCartState() {
      if (!sampleGrid) return;
      sampleGrid.querySelectorAll('[data-sample-add]').forEach(function(button) {
        const variantId = Number(button.dataset.sampleAdd || 0);
        if (!variantId) return;
        const isAvailable = button.dataset.sampleAvailable === 'true';
        if (!isAvailable) {
          button.textContent = 'Sold out';
          button.disabled = true;
          return;
        }
        const isInCart = sampleInCartVariantIds.indexOf(variantId) > -1;
        if (isInCart) {
          button.textContent = 'Added';
        } else {
          button.textContent = 'Add to cart';
          if (!button.hasAttribute('disabled') || button.getAttribute('aria-busy') !== 'true') {
            button.disabled = false;
          }
        }
      });
    }

    function galleryTags(item) {
      return normalizeTags(item.tags).concat([String(item.type || '').toLowerCase()]);
    }

    function renderGallery() {
      if (!galleryGrid) return;
      const source = Array.isArray(galleryGridProducts)
        ? galleryGridProducts
        : (Array.isArray(inspirationProducts) && inspirationProducts.length ? inspirationProducts : []);

      const list = source.filter(function(item) {
        return matchesTag(materialTags(item), activeGalleryTag);
      });

      galleryGrid.innerHTML = list.map(function(item) {
        return renderMaterialCard(item, false);
      }).join('');

      if (galleryEmpty) galleryEmpty.hidden = list.length > 0;
    }

    function populateProjectMaterials() {
      if (!projectMaterialSelect) return;
      projectMaterialSelect.innerHTML = '<option value="">Select material</option>' + materials.map(function(item) {
        return '<option value="' + item.id + '">' + item.name + (item.collection ? ' — ' + item.collection : '') + '</option>';
      }).join('');
    }

    function updateProjectSummary() {
      if (!projectSummary) return;
      const emptyText = projectSummaryCard?.dataset.projectEmptyText || 'Fill in the fields above to generate a quick project summary.';
      const labelProject = projectSummaryCard?.dataset.projectLabelProject || 'Project';
      const labelLocation = projectSummaryCard?.dataset.projectLabelLocation || 'Location';
      const labelApplication = projectSummaryCard?.dataset.projectLabelApplication || 'Application';
      const labelMaterial = projectSummaryCard?.dataset.projectLabelMaterial || 'Material';
      const labelGrout = projectSummaryCard?.dataset.projectLabelGrout || 'Recommended grout';
      const labelSealer = projectSummaryCard?.dataset.projectLabelSealer || 'Recommended sealer';
      const labelNotes = projectSummaryCard?.dataset.projectLabelNotes || 'Notes';
      const fallbackNotSpecified = projectSummaryCard?.dataset.projectFallbackNotSpecified || 'Not specified';
      const fallbackNotSelected = projectSummaryCard?.dataset.projectFallbackNotSelected || 'Not selected';
      const fallbackNone = projectSummaryCard?.dataset.projectFallbackNone || 'None';

      const values = {};
      sectionEl.querySelectorAll('[data-project-input]').forEach(function(input) {
        values[input.dataset.projectInput] = input.value;
      });
      const material = materials.find(function(item) { return item.id === values.material; });
      if (!values.project_name && !values.location && !values.application && !material && !values.notes) {
        projectSummary.textContent = emptyText;
        return;
      }
      projectSummary.innerHTML =
        '<strong>' + labelProject + ':</strong> ' + (values.project_name || fallbackNotSpecified) + '<br>' +
        '<strong>' + labelLocation + ':</strong> ' + (values.location || fallbackNotSpecified) + '<br>' +
        '<strong>' + labelApplication + ':</strong> ' + (values.application || fallbackNotSpecified) + '<br>' +
        '<strong>' + labelMaterial + ':</strong> ' + (material ? (material.name + (material.collection ? ' — ' + material.collection : '')) : fallbackNotSelected) + '<br>' +
        '<strong>' + labelGrout + ':</strong> ' + (material && material.grout ? material.grout : fallbackNotSpecified) + '<br>' +
        '<strong>' + labelSealer + ':</strong> ' + (material && material.sealer ? material.sealer : fallbackNotSpecified) + '<br>' +
        '<strong>' + labelNotes + ':</strong> ' + (values.notes || fallbackNone);

      updateQuoteSummary();
    }

    function sizeToSqFt(size) {
      const parts = String(size || '24x24').split('x').map(Number);
      const w = parts[0];
      const h = parts[1];
      if (!w || !h) return 4;
      return (w * h) / 144;
    }

    function convertToFeet(value, unit) {
      const number = Number(value || 0);
      if (!number) return 0;
      if (unit === 'in') return number / 12;
      if (unit === 'm') return number * 3.28084;
      return number;
    }

    function convertAreaToSqFt(value, unit) {
      const number = Number(value || 0);
      if (!number) return 0;
      if (unit === 'in') return number / 144;
      if (unit === 'm') return number * 10.7639;
      return number;
    }

    function convertFeetToUnit(value, unit) {
      const number = Number(value || 0);
      if (!number) return 0;
      if (unit === 'in') return number * 12;
      if (unit === 'm') return number / 3.28084;
      return number;
    }

    function convertSqFtToUnit(value, unit) {
      const number = Number(value || 0);
      if (!number) return 0;
      if (unit === 'in') return number * 144;
      if (unit === 'm') return number / 10.7639;
      return number;
    }

    function defaultWaste(application, layout) {
      let waste = 10;
      if (application === 'pool' || application === 'outdoor') waste = 12;
      if (layout === 'herringbone') waste += 5;
      if (layout === 'checkerboard') waste += 2;
      return waste;
    }

    function mapSearchProductToMaterial(product) {
      const imageUrl = product?.featured_image?.url || '';
      const priceValue = typeof product.price === 'number' ? product.price : 0;
      const money = (window.Shopify && typeof window.Shopify.formatMoney === 'function')
        ? window.Shopify.formatMoney(priceValue)
        : '';

      return {
        id: 'ajax-' + String(product.id || product.handle || product.title || Math.random()),
        name: product.title || '',
        collection: product.vendor || '',
        subtitle: product.product_type || '',
        color: '#C8B89A',
        tags: Array.isArray(product.tags) ? product.tags : [],
        product_tags: Array.isArray(product.tags) ? product.tags : [],
        sizes: '',
        grout: '',
        sealer: '',
        sampleable: false,
        product_url: product.url || '',
        product_image: imageUrl,
        product_price: money
      };
    }

    function itemSearchText(item) {
      return [
        item?.name,
        item?.collection,
        item?.subtitle,
        item?.product_type,
        item?.vendor,
        item?.title,
        item?.product_url
      ].join(' ').toLowerCase();
    }

    function scoreMaterialByTags(item, tags) {
      if (!Array.isArray(tags) || !tags.length) return 0;
      const itemTags = normalizeTags([]
        .concat(Array.isArray(item.tags) ? item.tags : [])
        .concat(Array.isArray(item.product_tags) ? item.product_tags : []));
      const haystack = itemSearchText(item);
      return tags.reduce(function(score, tag) {
        const needle = String(tag || '').toLowerCase();
        if (!needle) return score;
        const tagMatch = itemTags.indexOf(needle) > -1;
        const textMatch = haystack.indexOf(needle) > -1;
        return score + (tagMatch ? 2 : (textMatch ? 1 : 0));
      }, 0);
    }

    function includesAnyTag(item, tags) {
      const itemTags = normalizeTags([]
        .concat(Array.isArray(item.tags) ? item.tags : [])
        .concat(Array.isArray(item.product_tags) ? item.product_tags : []));
      return (tags || []).some(function(tag) {
        return itemTags.indexOf(String(tag || '').toLowerCase()) > -1;
      });
    }

    async function fetchProductsByTag(tag) {
      if (!tag || tag === 'all') return null;

      const query = encodeURIComponent(tag);
      const url = (window.Shopify?.routes?.root || '/') +
        'search/suggest.json?q=' + query +
        '&resources[type]=product' +
        '&resources[limit]=24' +
        '&resources[options][unavailable_products]=hide';

      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) return null;

      const payload = await response.json();
      const products = payload?.resources?.results?.products;
      if (!Array.isArray(products)) return null;

      return products.map(mapSearchProductToMaterial);
    }

    async function fetchProductsByTags(tags) {
      const normalized = Array.from(new Set((tags || [])
        .map(function(tag) { return String(tag || '').trim().toLowerCase(); })
        .filter(Boolean)));

      if (!normalized.length) return [];

      const chunks = normalized.slice(0, 8);
      const calls = chunks.map(function(tag) {
        return fetchProductsByTag(tag).catch(function() { return []; });
      });

      const results = await Promise.all(calls);
      const merged = [];
      const seen = new Set();

      results.forEach(function(list) {
        (list || []).forEach(function(item) {
          const key = String(item.id || item.product_url || item.name || Math.random());
          if (seen.has(key)) return;
          seen.add(key);
          merged.push(item);
        });
      });

      return merged;
    }

    function updateCalculator() {
      const values = {};
      calcInputs.forEach(function(input) {
        values[input.dataset.calcInput] = input.value;
      });
      const application = String(values.application || 'floor').toLowerCase();
      const layout = String(values.layout || 'straight').toLowerCase();
      const wasteField = sectionEl.querySelector('[data-calc-input="waste"]');
      if (document.activeElement !== wasteField && wasteField && wasteField.dataset.autofilled !== 'manual' && String(wasteField.value || '').trim() === '') {
        wasteField.value = defaultWaste(application, layout);
      }
      if (wallFields) {
        wallFields.hidden = !(application === 'wall' || application === 'shower' || application === 'backsplash');
      }

      const unit = String(values.unit || 'ft').toLowerCase();
      const length = convertToFeet(values.length, unit);
      const width = convertToFeet(values.width, unit);
      const height = convertToFeet(values.height, unit);
      const openings = convertAreaToSqFt(values.openings, unit);
      const waste = Number(values.waste || 0);

      let grossArea = 0;
      if (application === 'wall' || application === 'shower' || application === 'backsplash') {
        grossArea = (length * height) - openings;
      } else {
        grossArea = length * width;
      }

      if (!grossArea || grossArea <= 0) {
        if (calcResultsWrap) calcResultsWrap.hidden = false;
        sectionEl.querySelector('[data-calc-result="gross"]').textContent = '0.0000';
        sectionEl.querySelector('[data-calc-result="adjusted"]').textContent = '0.0000';
        sectionEl.querySelector('[data-calc-result="tiles"]').textContent = '0';
        sectionEl.querySelector('[data-calc-result="boxes"]').textContent = '0';
        saveCalculatorState();
        updateQuoteSummary();
        return;
      }

      const adjustedArea = grossArea * (1 + (waste / 100));
      const tileSqFt = sizeToSqFt(values.tile_size);
      const tiles = Math.ceil(adjustedArea / tileSqFt);
      const boxes = Math.ceil(tiles / 10);

      if (calcResultsWrap) calcResultsWrap.hidden = false;
      sectionEl.querySelector('[data-calc-result="gross"]').textContent = grossArea.toFixed(4);
      sectionEl.querySelector('[data-calc-result="adjusted"]').textContent = adjustedArea.toFixed(4);
      sectionEl.querySelector('[data-calc-result="tiles"]').textContent = tiles;
      sectionEl.querySelector('[data-calc-result="boxes"]').textContent = boxes;
      saveCalculatorState();
      updateQuoteSummary();
    }

    async function applyFilterToGroup(group, tag) {
      const filterTag = (tag || 'all').toLowerCase();

      if (group === 'materials') {
        activeMaterialTag = filterTag;
        materialGridProducts = null;
        if (materialGrid) {
          materialGrid.innerHTML = '<div class="nyct-hub__empty">Loading products...</div>';
        }

        try {
          const ajaxProducts = await fetchProductsByTag(filterTag);
          if (ajaxProducts && ajaxProducts.length) {
            materialGridProducts = ajaxProducts;
          }
        } catch (_error) {
          materialGridProducts = null;
        }

        renderMaterials();
        renderFeatured();
        renderSampleGrid();
      }
      if (group === 'gallery') {
        activeGalleryTag = filterTag;
        galleryGridProducts = null;
        if (galleryGrid) {
          galleryGrid.innerHTML = '<div class="nyct-hub__empty">Loading products...</div>';
        }

        try {
          const ajaxProducts = await fetchProductsByTag(filterTag);
          if (ajaxProducts && ajaxProducts.length) {
            galleryGridProducts = ajaxProducts;
          }
        } catch (_error) {
          galleryGridProducts = null;
        }

        renderGallery();
      }

      sectionEl.querySelectorAll('[data-filter-group="' + group + '"] [data-filter-tag]').forEach(function(btn) {
        btn.classList.toggle('is-active', (btn.dataset.filterTag || '').toLowerCase() === filterTag);
      });

      updateQuoteSummary();
    }

    function updateQuoteSummary() {
      if (!quoteSummaryProjectField && !quoteSummaryCalculatorField && !quoteSummaryAssistantField) return;

      const values = {};
      sectionEl.querySelectorAll('[data-project-input]').forEach(function(input) {
        values[input.dataset.projectInput] = input.value;
      });

      const calc = {};
      sectionEl.querySelectorAll('[data-calc-input]').forEach(function(input) {
        calc[input.dataset.calcInput] = input.value;
      });

      const assistantSelections = Array.from(sectionEl.querySelectorAll('[data-assistant-select]')).map(function(select) {
        return {
          label: select.dataset.assistantLabel || '',
          value: String(select.value || '').trim()
        };
      });

      const projectLines = [
        'Active tags',
        '- Materials tag: ' + (activeMaterialTag || 'all'),
        '- Inspiration tag: ' + (activeGalleryTag || 'all'),
        '',
        'Project Builder',
        '- Project: ' + (values.project_name || ''),
        '- Location: ' + (values.location || ''),
        '- Application: ' + (values.application || ''),
        '- Material id: ' + (values.material || ''),
        '- Notes: ' + (values.notes || '')
      ];

      const calculatorLines = [
        'Calculator',
        '- Area name: ' + (calc.name || ''),
        '- Application: ' + (calc.application || ''),
        '- Unit: ' + (calc.unit || ''),
        '- Length: ' + (calc.length || ''),
        '- Width: ' + (calc.width || '')
      ];
      const calcApplication = String(calc.application || '').toLowerCase();
      const showWallFields = calcApplication === 'wall' || calcApplication === 'shower' || calcApplication === 'backsplash';
      if (showWallFields || String(calc.height || '').trim() !== '') {
        calculatorLines.push('- Height: ' + (calc.height || ''));
      }
      if (showWallFields || String(calc.openings || '').trim() !== '') {
        calculatorLines.push('- Openings: ' + (calc.openings || ''));
      }
      calculatorLines.push(
        '- Tile size: ' + (calc.tile_size || ''),
        '- Layout: ' + (calc.layout || ''),
        '- Waste (%): ' + (calc.waste || ''),
        '- Gross area: ' + (sectionEl.querySelector('[data-calc-result="gross"]')?.textContent || ''),
        '- Adjusted area: ' + (sectionEl.querySelector('[data-calc-result="adjusted"]')?.textContent || ''),
        '- Estimated tiles: ' + (sectionEl.querySelector('[data-calc-result="tiles"]')?.textContent || ''),
        '- Estimated boxes: ' + (sectionEl.querySelector('[data-calc-result="boxes"]')?.textContent || '')
      );

      const assistantLines = [
        'Design Assistant',
        '- Selected filters: ' + (assistantSelections.map(function(selection) {
          if (!selection.value) return '';
          return selection.label + ': ' + selection.value;
        }).filter(Boolean).join(', ') || ''),
        '- Generated tags: ' + (lastAssistantTags.join(', ') || '')
      ];

      if (quoteSummaryProjectField) quoteSummaryProjectField.value = projectLines.join('\n');
      if (quoteSummaryCalculatorField) quoteSummaryCalculatorField.value = calculatorLines.join('\n');
      if (quoteSummaryAssistantField) quoteSummaryAssistantField.value = assistantLines.join('\n');
    }

    sectionEl.querySelectorAll('[data-filter-group]').forEach(function(groupEl) {
      const group = groupEl.dataset.filterGroup;
      groupEl.querySelectorAll('[data-filter-tag]').forEach(function(button) {
        button.addEventListener('click', function() {
          applyFilterToGroup(group, this.dataset.filterTag);
        });
      });
    });

    const wasteInput = sectionEl.querySelector('[data-calc-input="waste"]');
    const unitInput = sectionEl.querySelector('[data-calc-input="unit"]');
    let previousUnit = unitInput ? String(unitInput.value || 'ft').toLowerCase() : 'ft';

    function convertExistingValuesOnUnitChange(nextUnit) {
      const fromUnit = previousUnit;
      const toUnit = String(nextUnit || 'ft').toLowerCase();
      if (fromUnit === toUnit) return;

      ['length', 'width', 'height'].forEach(function(key) {
        const input = sectionEl.querySelector('[data-calc-input="' + key + '"]');
        if (!input || String(input.value || '').trim() === '') return;
        const asFeet = convertToFeet(input.value, fromUnit);
        const converted = convertFeetToUnit(asFeet, toUnit);
        input.value = Number.isFinite(converted) ? String(Number(converted.toFixed(4))) : input.value;
      });

      const openingsInput = sectionEl.querySelector('[data-calc-input="openings"]');
      if (openingsInput && String(openingsInput.value || '').trim() !== '') {
        const asSqFt = convertAreaToSqFt(openingsInput.value, fromUnit);
        const converted = convertSqFtToUnit(asSqFt, toUnit);
        openingsInput.value = Number.isFinite(converted) ? String(Number(converted.toFixed(4))) : openingsInput.value;
      }

      previousUnit = toUnit;
    }

    if (wasteInput) {
      wasteInput.addEventListener('input', function() {
        this.dataset.autofilled = 'manual';
      });
    }

    if (unitInput) {
      unitInput.addEventListener('change', function() {
        convertExistingValuesOnUnitChange(this.value);
        updateCalculator();
      });
    }

    calcInputs.forEach(function(input) {
      input.addEventListener('input', updateCalculator);
      input.addEventListener('change', updateCalculator);
    });

    sectionEl.querySelectorAll('[data-project-input]').forEach(function(input) {
      input.addEventListener('input', updateProjectSummary);
      input.addEventListener('change', updateProjectSummary);
    });

    const assistantRun = sectionEl.querySelector('[data-assistant-run]');
    if (assistantRun) {
      assistantRun.addEventListener('click', async function() {
        const selections = Array.from(sectionEl.querySelectorAll('[data-assistant-select]'))
          .map(function(select) {
            return {
              label: String(select.dataset.assistantLabel || '').trim(),
              raw: String(select.value || '').trim(),
              normalized: normalizeTag(select.value)
            };
          })
          .filter(function(entry) { return !!entry.raw; });

        const requestTerms = Array.from(new Set(selections
          .map(function(entry) { return entry.raw.toLowerCase(); })
          .filter(Boolean)));
        const requestTags = Array.from(new Set(selections
          .map(function(entry) { return entry.normalized; })
          .filter(Boolean)));
        lastAssistantTags = requestTerms.length ? requestTerms : requestTags;

        this.disabled = true;
        this.setAttribute('aria-busy', 'true');
        if (assistantOutput) {
          assistantOutput.textContent = 'Searching products by selected filters...';
        }

        try {
          const tagResults = await fetchProductsByTags(lastAssistantTags);

          const localPool = materials.concat(inspirationProducts || []).concat(samplesProducts || []);
          const merged = [];
          const seen = new Set();

          [tagResults, localPool].forEach(function(list) {
            (list || []).forEach(function(item) {
              const key = String(item.id || item.product_url || item.name || Math.random());
              if (seen.has(key)) return;
              seen.add(key);
              merged.push(item);
            });
          });

          const scoredTagMatches = merged
            .map(function(item) {
              return {
                item: item,
                score: scoreMaterialByTags(item, lastAssistantTags)
              };
            })
            .filter(function(entry) { return lastAssistantTags.length ? entry.score > 0 : true; })
            .sort(function(a, b) { return b.score - a.score; })
            .map(function(entry) { return entry.item; });

          const results = scoredTagMatches;

          if (!results.length) {
            if (assistantOutput) {
              assistantOutput.textContent = 'No products found for those selected tags. Try different dropdown combinations.';
            }
            if (assistantGrid) assistantGrid.innerHTML = '';
            updateQuoteSummary();
            return;
          }

          if (assistantOutput) {
            assistantOutput.innerHTML = 'Showing matches for filters: <strong>' + (selections.map(function(entry) {
              return entry.label + ': ' + entry.raw;
            }).join(', ') || 'all products') + '</strong>.';
          }
          if (assistantGrid) assistantGrid.innerHTML = results.filter(function(item) {
            const titleLower = String(item.name || '').toLowerCase();
            const urlLower = String(item.product_url || '').toLowerCase();
            return !titleLower.includes('sample') && !urlLower.includes('sample');
          }).slice(0, 12).map(function(item) { return renderMaterialCard(item, false); }).join('');
          updateQuoteSummary();
        } finally {
          this.disabled = false;
          this.removeAttribute('aria-busy');
        }
      });
    }

    sectionEl.querySelectorAll('[data-assistant-select]').forEach(function(input) {
      input.addEventListener('input', updateQuoteSummary);
      input.addEventListener('change', updateQuoteSummary);
    });

    sectionEl.querySelectorAll('[data-quote-input]').forEach(function(input) {
      input.addEventListener('focus', updateQuoteSummary);
    });

    renderFeatured();
    renderMaterials();
    renderGallery();
    populateProjectMaterials();
    updateProjectSummary();
    restoreCalculatorState();
    updateCalculator();
    renderSampleGrid();
    renderSampleCart();
    refreshSampleCartStatus();
    showTab(initialTab || 'home');
    updateQuoteSummary();
  }

  function initAll() {
    document.querySelectorAll('.nyct-hub[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
